import { inject as o } from "vue";
import { elPaginationKey as i } from "./index657.js";
const e = () => o(i, {});
export {
  e as usePagination
};
